<template>
  <v-app dark>
    <router-view></router-view>
    <!-- global snackbar -->
    <v-snackbar
      :timeout="snackbar.timeout?snackbar.timeout:3000"
      app
      top
      centered
      :color="snackbar.color"
      v-model="snackbar.show"
    >
      <span v-html="snackbar.text">
      </span>
      <template v-slot:action="{ attrs }">
        <v-btn icon v-bind="attrs" @click="snackbar.show = false">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </template>
    </v-snackbar>
  </v-app>
</template>

<script>
export default {
  data() {
    return {
      rightDrawer: false,
      snackbar: {
        show: false,
        text: '',
        color: ''
      }
    }
  },
  methods: {
    setTokenExpiration() {
      var token = JSON.parse(localStorage.getItem("user")).accessToken
      var base64Url = token.split('.')[1];
      var base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
      var jsonPayload = decodeURIComponent(atob(base64).split('').map(function(c) {
          return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
      }).join(''))

      // var now = Date.now();
      var nowSeconds = new Date().getTime() / 1000;
      // var tokenIssued = JSON.parse(jsonPayload).iat
      var tokenExpires = JSON.parse(jsonPayload).exp

      // console.log(`tokenExpires: ${tokenExpires}`)
      // console.log(`nowSeconds: ${nowSeconds}`)

      var timeToLogout = tokenExpires - nowSeconds

      timeToLogout = timeToLogout < 1 ? 1 : timeToLogout

      setTimeout(() => {
        this.$store.dispatch('auth/logout')
        setTimeout(() => this.$router.push('/auth/login'), 1000)
      }, ((timeToLogout) + 3) * 1000)
    },

    timeout(ms) {
      return new Promise(resolve => setTimeout(resolve, ms));
    },
  },
  mounted() {
    if (typeof window !== undefined && window._LOL2P === undefined) {
      window._LOL2P = this
    }

    if (localStorage.getItem("user")) {
      this.setTokenExpiration()
    }
  },
  created() {
    this.$on('LOGGED_IN', (e) => {
      this.setTokenExpiration()
    })

    this.$on('SHOW_SNACKBAR', (e) => {
      this.snackbar = {
        show: true,
        text: e.text,
        color: e.color,
        timeout: e.timeout
      }
    })
    this.$on('AUTH_FAILED', (e) => {
      this.snackbar = {
        show: true,
        text: 'Auth Failed',
        color: 'error'
      }
      this.$router.push({
        path: '/auth/login',
        query: {
          redirect: this.$route.path
        }
      })
    })
    this.$on('SERVER_ERROR', () => {
      this.snackbar = {
        show: true,
        text: 'Server Error',
        color: 'error'
      }
    })
  }
}
</script>

<style lang="sass" scoped>
.setting-fab
  top: 50% !important
  right: 0
  border-radius: 0
</style>